module.exports = __webpack_public_path__ + "static/media/hall-PI.0d4d9ae1.svg";